import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";   // ✅ ADD THIS

const slides = [
    {
        image: "/images/slider/banner-1.jpg",
        title: "2001 से अब तक भरोसे का नाम",
        subtitle: "श्री बालाजी मसाले – हर घर की पहली पसंद",
    },
    {
        image: "/images/slider/banner-2.jpg",
        title: "शुद्ध और ताजे मसाले",
        subtitle: "हर रसोई में भरोसे का स्वाद",
    },
    {
        image: "/images/slider/banner-3.jpg",
        title: "गुणवत्ता पर कोई समझौता नहीं",
        subtitle: "FSSAI प्रमाणित और विश्वसनीय उत्पाद",
    },

];

export default function Glowing3DCarousel() {
    const [current, setCurrent] = useState(0);
    const navigate = useNavigate();   // ✅ ADD THIS

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % slides.length);
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    const nextSlide = () => {
        setCurrent((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrent((prev) =>
            prev === 0 ? slides.length - 1 : prev - 1
        );
    };

    return (
        <div className="relative w-full py-10 md:py-14 flex justify-center items-center overflow-hidden">
            <div className="relative w-full max-w-6xl h-[350px] md:h-[420px] flex items-center justify-center">

                {slides.map((slide, index) => {
                    const position =
                        (index - current + slides.length) % slides.length;

                    let style = "";

                    if (position === 0) {
                        style = "translate-x-0 scale-100 z-30 opacity-100";
                    } else if (position === 1) {
                        style = "translate-x-[70%] scale-75 z-20 opacity-60";
                    } else {
                        style = "-translate-x-[70%] scale-75 z-20 opacity-60";
                    }

                    return (
                        <div
                            key={index}
                            className={`absolute transition-all duration-700 ease-in-out ${style}`}
                        >
                            <div
                                className={`relative w-[280px] sm:w-[350px] md:w-[450px] rounded-2xl overflow-hidden bg-white transition-all duration-500 ${position === 0
                                    ? "shadow-[0_0_40px_#ff0000]"
                                    : "shadow-xl"
                                    }`}
                            >
                                {/* Image */}
                                <div className="w-full h-[220px] md:h-[260px] overflow-hidden">
                                    <img
                                        src={slide.image}
                                        alt={slide.title}
                                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                                    />
                                </div>

                                {/* Text */}
                                <div className="p-6 text-center">
                                    <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-2 text-gray-800">
                                        {slide.title}
                                    </h2>

                                    <p className="text-sm sm:text-base text-gray-600 mb-4">
                                        {slide.subtitle}
                                    </p>

                                    {/* ✅ UPDATED BUTTON */}
                                    <button
                                        onClick={() => navigate("/products")}
                                        className="relative z-50 bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-full font-semibold transition"
                                    >
                                        हमारे उत्पाद देखें
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Arrows */}
            <button
                onClick={prevSlide}
                className="absolute left-5 text-white text-3xl z-40"
            >
                ❮
            </button>

            <button
                onClick={nextSlide}
                className="absolute right-5 text-white text-3xl z-40"
            >
                ❯
            </button>
        </div>
    );
}